<script setup lang="ts">
import LawyerCard from '@/widgets/LawyerCard/index';
import type { ILawyerCardInfo } from '@/entities/lawyer/model/types/lawyer';

withDefaults(
  defineProps<{
    authors?: ILawyerCardInfo[];
    isShowMore?: boolean;
  }>(),
  {
    authors: () => [],
    isShowMore: false,
  },
);

const emit = defineEmits<{ (e: 'load'): void }>();

const isMobile: boolean = useIsMobile();

const loadMore = (): void => emit('load');
</script>

<template>
  <div :class="['authors-experts', { _mobile: isMobile }]" data-testid="authors-experts">
    <ul class="authors-experts__list">
      <li v-for="author in authors" :key="author.id" class="authors-experts__item">
        <LawyerCard
          :data="author"
          is-catalog
          is-editor-card
          is-categories-collapsible
          :is-show-actions="false"
          :is-show-footer="false"
          :is-show-reviews-count="false"
          :is-show-experience="false"
          :max-visible-categories="3"
        />
      </li>
    </ul>
    <button
      v-if="isShowMore"
      class="authors-experts__more"
      type="button"
      data-testid="authors-experts-more"
      aria-label="Показать ещё"
      @click.prevent="loadMore"
    >
      Показать ещё
      <AppIcon class="authors-experts__more-icon" name="ArrowDown" />
    </button>
  </div>
</template>

<style lang="less">
.authors-experts {
  .flex-column(@size-x8);

  &__list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: @size-x6;
  }

  &__item {
    display: flex;
  }

  &__more {
    .color-change-hover();

    display: inline-flex;
    align-items: center;
    align-self: flex-start;
    gap: @size-x2;
    font-size: @size-x4;
    line-height: 130%;
    font-weight: 700;
    color: @color-elephant;

    .app-icon {
      width: @size-x4;
      height: @size-x4;

      path {
        stroke: @color-persimmon;
      }
    }
  }

  &._mobile &__list {
    grid-template-columns: 1fr;
  }
}
</style>
